import { ComponentBackground, MoreLinkStyle, PageTheme, SubTitleStyle, TitleStyle } from '@/types/cms';
import { parseJson } from '@/utils/parseJson';
import { isEmptyObject } from '@/utils/tool';
import { useMemo } from 'react';
import { ComponentProperties } from '@/types/cms';

type EmptyObject = {
  [K in string | number]: never;
};

type UseComponentThemeReturns = {
  titleStyle: TitleStyle | EmptyObject;
  subTitleStyle: SubTitleStyle | EmptyObject;
  moreLinkStyle: MoreLinkStyle | EmptyObject;
  background: ComponentBackground | EmptyObject;
  pageTheme: PageTheme | EmptyObject;
};

type UseComponentTheme = (params: {
  properties: ComponentProperties;
  pageTheme: string | PageTheme;
}) => UseComponentThemeReturns;

/**
 * @des 导出处理后的cms组件样式
 * @param param0
 * @returns
 */
export const useComponentTheme: UseComponentTheme = ({ properties, pageTheme }) => {
  const MemoedpageTheme = useMemo(() => {
    if (typeof pageTheme === 'string') {
      return parseJson(pageTheme) ?? {};
    }
    if (!isEmptyObject(pageTheme)) {
      return pageTheme;
    }
    return {};
  }, [pageTheme]);

  const titleStyle: TitleStyle = useMemo(() => {
    const _style = parseJson(properties?.title_style) ?? {};
    const _color = _style?.color || MemoedpageTheme?.title_color;
    const _fontSize = _style?.font_size || MemoedpageTheme?.title_font_size;

    if (_color) _style.color = _color;
    if (_fontSize) _style.font_size = _fontSize;

    return _style;
  }, [MemoedpageTheme?.title_color, MemoedpageTheme?.title_font_size, properties?.title_style]);

  const moreLinkStyle = useMemo(() => {
    const _style = parseJson(properties?.more_link_style) ?? {};
    const _color = _style?.color || MemoedpageTheme?.title_color;

    if (_color) _style.color = _color;
    return _style;
  }, [MemoedpageTheme?.title_color, properties?.more_link_style]);

  const subTitleStyle = useMemo(() => {
    const _style = parseJson(properties?.sub_title_style) ?? {};
    const _color = _style?.color || MemoedpageTheme?.title_color;

    if (_color) _style.color = _color;
    return _style;
  }, [MemoedpageTheme?.title_color, properties?.sub_title_style]);

  const background = useMemo(() => {
    const _style = parseJson(properties?.background) ?? {};
    return _style;
  }, [properties?.background]);

  return {
    titleStyle,
    subTitleStyle,
    moreLinkStyle,
    background,
    pageTheme: MemoedpageTheme
  };
};
